import {
  ApiBlueprint,
  createFrontendPlugin,
  githubAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import GitHubIcon from '@material-ui/icons/GitHub';
import { GithubClient, githubApiRef } from './api';
import { isGithubAvailable } from './repository';

export default createFrontendPlugin({
  pluginId: 'github',
  title: 'GitHub',
  icon: <GitHubIcon />,
  extensions: [
    ApiBlueprint.make({
      params: defineParams =>
        defineParams({
          api: githubApiRef,
          deps: { auth: githubAuthApiRef },
          factory: ({ auth }) => new GithubClient(auth),
        }),
    }),
    EntityContentBlueprint.make({
      params: {
        path: '/github',
        title: 'GitHub',
        group: 'development',
        filter: isGithubAvailable,
        loader: () =>
          import('./components/GithubPage').then(m => <m.GithubPage />),
      },
    }),
  ],
});
